import { ErrorBox, FormGroup, Label } from "@evr/ui/TextInput/styles";

import { StyledSelect } from "./styles";

export type SelectWithLabelDataType = { key: string | number; value: string | number; label: string };
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  id?: string;
  label?: string;
  items: SelectWithLabelDataType[];
  error?: boolean;
  name?: string;
  disabled?: boolean;
  isChangedByKey?: boolean;
  errorText?: string;
}
export const SelectWithLabel = ({
  id,
  label,
  items,
  error,
  disabled,
  isChangedByKey,
  value,
  placeholder,
  errorText,
  ...rest
}: SelectProps) => {
  return (
    <FormGroup className="select-with-label-group">
      {label && (
        <Label htmlFor={id} disabled={disabled}>
          {label}
        </Label>
      )}
      <StyledSelect id={id} error={error} disabled={disabled} value={value} {...rest}>
        {!value && <option>{placeholder ? placeholder : "Select..."}</option>}
        {items.map(item => {
          return (
            <option key={item.key} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </StyledSelect>
      {error && <ErrorBox>{errorText}</ErrorBox>}
    </FormGroup>
  );
};
